document.addEventListener('DOMContentLoaded', () => {
  console.log('firekultur-page-classifier.js: Script loaded and DOMContentLoaded event fired');

  // Read settings from the Firekultur Page Classifier section
  const classifier = document.querySelector('#firekultur-page-classifier');
  if (!classifier) {
    console.error('Firekultur Page Classifier section not found');
    // Default to StaticPage and PrintablePage if the section is missing
    document.dispatchEvent(new CustomEvent('PageClassified', { detail: { pageType: 'StaticPage' } }));
    document.dispatchEvent(new CustomEvent('PagePrintability', { detail: { printable: true } }));
    return;
  }

  const pageType = classifier.dataset.pageType || 'StaticPage';
  const printablePage = classifier.dataset.printablePage || 'PrintablePage';

  // Dispatch PagePrintability event
  const isPrintable = printablePage === 'PrintablePage';
  document.dispatchEvent(new CustomEvent('PagePrintability', { detail: { printable: isPrintable } }));
  console.log(`Page printability set to: ${isPrintable}`);

  // Classify the page
  const dynamicSections = new Set();

  // Listen for NotReadyForPrint signals to detect dynamic sections
  document.addEventListener('NotReadyForPrint', (event) => {
    const sectionId = event.detail.sectionId;
    if (sectionId) {
      dynamicSections.add(sectionId);
      console.log(`Detected dynamic section: ${sectionId}. Total dynamic sections: ${dynamicSections.size}`);
    }
  });

  // After a short timeout, classify the page based on settings and signals
  setTimeout(() => {
    let finalPageType = pageType;
    if (pageType === 'DynamicPage' && dynamicSections.size === 0) {
      finalPageType = 'StaticPage'; // Fallback to StaticPage if no dynamic sections detected
      console.log('No dynamic sections detected; falling back to StaticPage');
    } else if (pageType === 'StaticPage' && dynamicSections.size > 0) {
      finalPageType = 'DynamicPage'; // Override to DynamicPage if dynamic sections are present
      console.log('Dynamic sections detected; overriding to DynamicPage');
    }

    document.dispatchEvent(new CustomEvent('PageClassified', { detail: { pageType: finalPageType } }));
    console.log(`Page classified as: ${finalPageType}`);
  }, 500); // 500ms timeout to allow dynamic sections to dispatch signals
});